export const programId = '621917e13454021f2216c59a';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },

    logLevel: 'error',
};
